module.exports = __webpack_public_path__ + "dash_20_app_assets/img/WOP.40c9b84d.png";